export function calcCols(pc, pageGrid = {}, orientation = 'horizontal', displayMode = 'desktop') {
	if(orientation === "vertical" || displayMode !== "desktop") {
		return pageGrid?.[displayMode]?.colCount;
	}
	return pc % 2 === 0 ?  (pc / 2) + 1 : (pc + 1) / 2;
}
